import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorTradingVoucher = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M4.92 7.1c-.324.314-.42.575-.42.775 0 .2.096.461.42.775.326.315.837.634 1.53.917 1.383.566 3.345.933 5.55.933 2.205 0 4.167-.367 5.55-.933.693-.283 1.204-.602 1.53-.917.324-.314.42-.575.42-.775 0-.2-.096-.461-.42-.775-.326-.315-.837-.634-1.53-.917-1.383-.566-3.345-.933-5.55-.933-2.205 0-4.167.367-5.55.933-.693.283-1.204.602-1.53.917Zm.962-2.306C7.486 4.138 9.65 3.75 12 3.75c2.351 0 4.514.388 6.118 1.044.8.328 1.496.736 2.005 1.228.511.494.877 1.12.877 1.853 0 .732-.366 1.359-.877 1.853-.509.492-1.206.9-2.005 1.228C16.514 11.612 14.35 12 12 12c-2.35 0-4.514-.388-6.118-1.044-.8-.328-1.496-.736-2.005-1.228C3.366 9.234 3 8.608 3 7.875c0-.732.366-1.359.877-1.853.509-.492 1.206-.9 2.005-1.228ZM4.723 15.174a.75.75 0 0 1 .071 1.058c-.224.256-.294.47-.294.643 0 .2.096.461.42.774.326.316.837.635 1.53.918 1.383.566 3.345.933 5.55.933 2.205 0 4.167-.367 5.55-.933.693-.283 1.204-.602 1.53-.918.324-.313.42-.575.42-.774 0-.154-.055-.337-.22-.554a.75.75 0 1 1 1.19-.91c.322.42.53.915.53 1.464 0 .732-.366 1.358-.877 1.853-.509.492-1.206.9-2.005 1.227C16.514 20.611 14.35 21 12 21c-2.35 0-4.514-.389-6.118-1.045-.8-.327-1.496-.735-2.005-1.227-.511-.495-.877-1.12-.877-1.853 0-.625.268-1.176.665-1.63a.75.75 0 0 1 1.058-.071Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M4.723 10.685a.75.75 0 0 1 .071 1.059c-.224.256-.294.47-.294.643 0 .2.096.46.42.774.326.316.837.634 1.53.918 1.383.565 3.345.932 5.55.932 2.205 0 4.167-.367 5.55-.932.693-.284 1.204-.602 1.53-.918.324-.313.42-.575.42-.774 0-.154-.055-.337-.22-.554a.75.75 0 1 1 1.19-.911c.322.42.53.915.53 1.464 0 .733-.366 1.36-.877 1.853-.509.492-1.206.9-2.005 1.228-1.604.656-3.767 1.045-6.118 1.045-2.35 0-4.514-.389-6.118-1.045-.8-.327-1.496-.736-2.005-1.228C3.366 13.745 3 13.12 3 12.386c0-.624.268-1.175.665-1.63a.75.75 0 0 1 1.058-.07Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorTradingVoucher;
